// extracted by mini-css-extract-plugin
module.exports = {"footerLink":"FooterLink_footerLink__4_YKf","linkContainer":"FooterLink_linkContainer__dyhnz","linkItem":"FooterLink_linkItem___A8M3","link":"FooterLink_link__LJ5Ng"};